export const CONFIG = {
  WHATSAPP_NUMBER: '50685316690', // Editable
  EXPRESS_FEE: 1500, // Editable, in colones
  CURRENCY_SYMBOL: '₡',
  LOGO_URL:
    'https://cdn.magicpatterns.com/uploads/4BsVfyjJDkoxEMJRHJXWHV/WhatsApp_Image_2026-03-10_at_19.46.16.jpg',
  APP_NAME: 'Alma Verde',
  APP_TAGLINE: 'Comida saludable hecha a tu gusto',
}
